export const CANVAS_ACTIONS = {
	NOTHING: 'nothing',
	SCALING_ROTATION: 'scaling-rotating',
	MOVING: 'moving',
	DELETING: 'deleting'
};
